import * as THREE from 'three'
import { useState, useRef, useEffect, Suspense } from 'react'
import { useFrame } from '@react-three/fiber'
import { Float, Html, useGLTF, useCursor, useVideoTexture, useTexture } from '@react-three/drei'
import { preload_assets } from '/data/PortfolioData'
import { getTotalScrollHeight, scrollToPosition, isMobile } from '/Utils'

const enableLogs = false
const enableLogIndex = enableLogs ? 0 : -1

const AnimationStatus = {
    STOPPED: 'stopped',
    PLAYING_ZOOM_IN: 'playingZoomIn',
    PLAYING_ZOOM_IN_REVERSE: 'playingZoomInReverse'
}

const PositionStatus = {
    NORMAL: 'normal',
    ZOOM_IN: 'zoomIn',
}

const distanceToCenterThreshold = 0.30

function getDistanceToCenter(movingBall, experience) {
    const movilBallWorldPosition = movingBall.getWorldPosition(new THREE.Vector3())

    var cacharroNoFloatReferenceToHighlightWorldPosition = new THREE.Vector3()
    // correction to position the debug highlight ball closer to experience-no-float reference position
    cacharroNoFloatReferenceToHighlightWorldPosition.x = movilBallWorldPosition.x
    cacharroNoFloatReferenceToHighlightWorldPosition.y = movilBallWorldPosition.y + 0.8
    cacharroNoFloatReferenceToHighlightWorldPosition.z = movilBallWorldPosition.z + 1.0
    // console.log("1-cacharroNoFloatReferenceToHighlightWorldPosition: " + JSON.stringify(cacharroNoFloatReferenceToHighlightWorldPosition))

    // var experienceCacharroMesh = experience.getObjectByName('experience-float-mesh')
    var experienceCaharroMeshNoFloatWorldPosition = new THREE.Vector3()
    var experienceCacharroNofloatReferenceMesh = experience.getObjectByName('experience-no-float')
    // console.log("experienceCacharroNofloatReferenceMesh")
    // console.log(experienceCacharroNofloatReferenceMesh)
    experienceCacharroNofloatReferenceMesh.getWorldPosition(experienceCaharroMeshNoFloatWorldPosition)
    let distance = cacharroNoFloatReferenceToHighlightWorldPosition.distanceTo(experienceCaharroMeshNoFloatWorldPosition)
    return distance
}

function updateDebugHighlightExperienceDistanceToCenterBall(
    movingBall,
    debugHighlightExperienceDistanceToCenterBallObject,
) {
    let movilBallWorldPosition = new THREE.Vector3()
    movingBall.getWorldPosition(movilBallWorldPosition)

    var cacharroNoFloatReferenceToHighlightWorldPosition = new THREE.Vector3()
    // correction to position the debug highlight ball closer to experience-no-float reference position
    cacharroNoFloatReferenceToHighlightWorldPosition.x = movilBallWorldPosition.x
    cacharroNoFloatReferenceToHighlightWorldPosition.y = movilBallWorldPosition.y + 0.8
    cacharroNoFloatReferenceToHighlightWorldPosition.z = movilBallWorldPosition.z + 1.0
    // console.log("1-cacharroNoFloatReferenceToHighlightWorldPosition: " + JSON.stringify(cacharroNoFloatReferenceToHighlightWorldPosition))

    let cameraWorldPosition = new THREE.Vector3()
    let cacharroNoFloatReferenceToLocalPosition = new THREE.Vector3()
    cacharroNoFloatReferenceToLocalPosition.copy(cacharroNoFloatReferenceToHighlightWorldPosition)
    debugHighlightExperienceDistanceToCenterBallObject.parent.getWorldPosition(cameraWorldPosition)
    cacharroNoFloatReferenceToLocalPosition.x -= cameraWorldPosition.x
    cacharroNoFloatReferenceToLocalPosition.y -= cameraWorldPosition.y
    cacharroNoFloatReferenceToLocalPosition.z -= cameraWorldPosition.z
    debugHighlightExperienceDistanceToCenterBallObject.position.set(
        cacharroNoFloatReferenceToLocalPosition.x,
        cacharroNoFloatReferenceToLocalPosition.y,
        cacharroNoFloatReferenceToLocalPosition.z
    )
}

function updatePorfolioVisualComponentCacharroHeaderText(
    movingBall,
    experiencesRef,
    debugHighlightExperienceDistanceToCenterBallObject,
) {
    // disable code because there is no title html floating
    // if (debugHighlightExperienceDistanceToCenterBallObject.parent == null) {
    //     console.log("debugHighlightExperienceDistanceToCenterBallObject.parent == null, skipping. Probably/hopefully tweaking leva values")
    //     return
    // }

    // for (var idx = 0; idx < experiencesRef.length; idx++) {
    //     var experience = experiencesRef[idx].current
    //     // var float = experience.getObjectByName("experience-the-float")
    //     // var html = experience.children[1]
    //     // console.log("html")
    //     // console.log(html)

    //     const distance = getDistanceToCenter(movingBall, experience)
    //     // if (idx == 0) { console.log("distance to mesh id: " + idx + ": " + distance) }

    //     // var floatSpeedValue = 100
    //     var titleHtml = document.getElementsByClassName('pvc-experience-title')[idx]
    //     if (Math.abs(distance) < distanceToCenterThreshold) {
    //         // floatSpeedValue = 100
    //         // mesh.scale.x = 2
    //         // mesh.scale.y = 2
    //         if (titleHtml.classList.contains('pvc-experience-title-hidden')) {
    //             titleHtml.classList.remove('pvc-experience-title-hidden')
    //         }
    //     }
    //     else {
    //         // floatSpeedValue = 0
    //         // mesh.scale.x = 1
    //         // mesh.scale.y = 1
    //         if (!titleHtml.classList.contains('pvc-experience-title-hidden')) {
    //             titleHtml.classList.add('pvc-experience-title-hidden')
    //         }
    //     }
    //     // experiencesFloatValues[idx] = floatSpeedValue
    // }
}

export default function PortfolioVisualComponent({
    index,
    experienceRef,
    startExperiencesRotationCameraUnits,
    portfolioAssetsAnimations,
    cacharroHolder,
    cacharroPositionY,
    cacharroMaterial,
    buttonsColor,
    floatSpeedValue,
    experienceData,
    cancelZoomIn,
    movingBall,
}) {
    // console.log("recreating PortfolioVisualComponent index[" + index + "]!, calling return")

    function onClickEventHandler(event) {
        event.stopPropagation()

        const scrollPercent = experienceData.scrollPositionPercent
        // const scrollCameraUnits = scrollPercent * totalCameraScrollCameraUnits
        // const scrollCameraUnitsTwoDecimals = scrollCameraUnits.toFixed(2)
        // const scrollPercentInt = Math.floor(scrollPercent * 100)
        // var scrollStringDebug = `${scrollCameraUnitsTwoDecimals}cu (${scrollPercentInt}%)`
        // console.log("PortfolioVisualComponent. onClickEventHandler. scrollStringDebug: " + scrollStringDebug)
        const scrollPositionPixels = scrollPercent * getTotalScrollHeight()
        // console.log("PortfolioVisualComponent. onClickEventHandler. scroll to " + scrollPositionPixels)

        if (animationState.animationStatus != AnimationStatus.STOPPED) { return }
        if (animationState.positionStatus == PositionStatus.ZOOM_IN) {
            // console.log("PVC idx[" + index + "]. onClickEventHandler. animationStatus: " + animationState.animationStatus)
            playCacharroAnimationZoomInReverse()
            return
        }

        const experienceInfoContainerZoomTooltip = document.getElementsByClassName('experience-info-container-zoom-tooltip')[0]
        experienceInfoContainerZoomTooltip.dataset.userClickedOnce = true
        experienceInfoContainerZoomTooltip.classList.add("hide")
        experienceInfoContainerZoomTooltip.classList.remove("show")

        playCacharroAnimationZoomIn()

        animationState.scrollingTowardsPosition = scrollPositionPixels
        scrollToPosition(scrollPositionPixels, () => {
            if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. onClickEventHandler. scrollToPosition stopped scrolling") }
            animationState.scrollingTowardsPosition = -1
        })
    }

    function onCursorHoverEventHandler(event, hover) {
        // console.log("onCursorHoverEventHandler. hover " + hover + ". event type: ", event.type)

        if (hovered === hover) { return }

        // TODO: this makes recreating the component on hover :(
        event.stopPropagation()
        setCursorHovered(hover)

        // cacharroMaterialHolderMeshRef.current.scale.x = hover ? 2 : 1
        // cacharroMaterialHolderMeshRef.current.material.color.set(hover ? 0x366bb0 : cacharroMaterialColor)

        // if (event.type == "click" && !hover) {
        //     console.log("onCursorHoverEventHandler. hover " + hover + ". animationState: ", animationState, " status: ", animationState.animationStatus, " time: ", animationState.animationTime)
        //     if (animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN_REVERSE) { return }
        //     if (animationState.animationTime <= 0.01) { return }

        //     if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. onCursorHoverEventHandler. PLAYING_ZOOM_IN_REVERSE animationStatus: " + animationState.animationStatus) }
        //     playCacharroAnimationZoomInReverse()
        // }
    }

    function attachCacharroMeshToStopFloating() {
        // move mesh to the non-float group
        var theMesh = experienceRef.current.getObjectByName("experience-float-mesh")
        // console.log("theMesh")
        // console.log(theMesh)
        var noFloat = experienceRef.current.getObjectByName("experience-no-float")
        // console.log("noFloat")
        // console.log(noFloat)

        noFloat.attach(theMesh)
        theMesh.position.set(0, 0, 0)
        theMesh.rotation.set(0, 0, 0)
    }

    function attachCacharroMeshToStartFloating() {
        var theMesh = experienceRef.current.getObjectByName("experience-float-mesh")
        var float = experienceRef.current.getObjectByName("experience-the-float").children[0]
        float.attach(theMesh)
    }

    function hideExperienceInfoContainerData() {
        const experienceInfoContainer = document.getElementsByClassName('experience-info-container')[0]
        if (experienceInfoContainer == undefined || experienceInfoContainer.dataset.experienceIndex != index) { return }
        if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. hideExperienceInfoContainerData. experienceInfoContainer.dataset.experienceIndex: " + experienceInfoContainer.dataset.experienceIndex) }
        experienceInfoContainer.dataset.experienceIndex = -1
        experienceInfoContainer.classList.remove("show")
        experienceInfoContainer.classList.add("hide")

        const experienceInfoContainerZoomTooltip = document.getElementsByClassName('experience-info-container-zoom-tooltip')[0]
        experienceInfoContainerZoomTooltip.classList.add("hide")
        experienceInfoContainerZoomTooltip.classList.remove("show")
    }

    function showExperienceInfoContainerData(experienceData) {
        const experienceInfoContainer = document.getElementsByClassName('experience-info-container')[0]
        // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. showExperienceInfoContainerData. experienceInfoContainer.dataset.experienceIndex: " + experienceInfoContainer.dataset.experienceIndex) }
        if (experienceInfoContainer.dataset.experienceIndex == index) {
            // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. RETURN showExperienceInfoContainerData. experienceInfoContainer.dataset.experienceIndex: " + experienceInfoContainer.dataset.experienceIndex) }
            return
        }
        if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. showExperienceInfoContainerData. experienceInfoContainer.dataset.experienceIndex: " + experienceInfoContainer.dataset.experienceIndex) }
        experienceInfoContainer.dataset.experienceIndex = index
        experienceInfoContainer.classList.add("show")
        experienceInfoContainer.classList.remove("hide")

        const experienceInfoContainerZoomTooltip = document.getElementsByClassName('experience-info-container-zoom-tooltip')[0]
        if (!experienceInfoContainerZoomTooltip.dataset.userClickedOnce) {
            experienceInfoContainerZoomTooltip.classList.add("show")
            experienceInfoContainerZoomTooltip.classList.remove("hide")
        }

        // update inner experience-info-title with experienceData.title
        const experienceInfoTitle = experienceInfoContainer.getElementsByClassName('experience-info-title')[0]
        experienceInfoTitle.innerHTML = experienceData.title

        // update inner experience-info-description with experienceData.description
        const experienceInfoDescription = experienceInfoContainer.getElementsByClassName('experience-info-description')[0]
        experienceInfoDescription.innerHTML = experienceData.description

        // update inner experience-info-tags with experienceData.tags
        const experienceInfoTags = experienceInfoContainer.getElementsByClassName('experience-info-tags')[0]
        experienceInfoTags.innerHTML = experienceData.tags.map(tag => `<span class="experience-info-tag">${tag}</span>`).join('')

        // update inner experience-info-links with experienceData.links
        const experienceInfoLinks = experienceInfoContainer.getElementsByClassName('experience-info-links')[0]
        experienceInfoLinks.innerHTML = experienceData.links.map(link => `<a class="experience-info-link" href="${link.url}" target="_blank">🔗 ${link.type}</a>`).join('')
    }

    function playCacharroAnimationZoomIn() {
        attachCacharroMeshToStopFloating()
        cacharroMaterialHolderMeshRef.current.material.map.source.data.play()
        animationState.animationStatus = AnimationStatus.PLAYING_ZOOM_IN
        animationState.positionStatus = PositionStatus.ZOOM_IN
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.classList.add('canvas-container-blur')
        canvasContainer.classList.remove('canvas-container-blur-out')
        // showExperienceInfoContainerData(experienceData)
        // console.log("playCacharroAnimationZoomIn. experienceInfoContainer: ", experienceInfoContainer.dataset.experienceIndex)
        // console.log(experienceInfoContainer)
        if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. playCacharroAnimationZoomIn. animationState: " + JSON.stringify(animationState)) }
    }

    function playCacharroAnimationZoomInReverse() {
        attachCacharroMeshToStartFloating()
        cacharroMaterialHolderMeshRef.current.material.map.source.data.pause()
        animationState.animationStatus = AnimationStatus.PLAYING_ZOOM_IN_REVERSE
        animationState.positionStatus = PositionStatus.NORMAL
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.classList.remove('canvas-container-blur')
        canvasContainer.classList.add('canvas-container-blur-out')
        if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. playCacharroAnimationZoomInReverse. animationState: " + JSON.stringify(animationState)) }
    }

    function stopCacharroAnimationZoomIn(newPositionStatus, finalTime) {
        animationState.animationStatus = AnimationStatus.STOPPED
        animationState.positionStatus = newPositionStatus
        cacharroZoomInAnimationAction.getMixer().setTime(finalTime)
        if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. stopCacharroAnimationZoomIn. animationState: " + JSON.stringify(animationState)) }
    }

    useEffect(() => {
        if (animationState.positionStatus == PositionStatus.NORMAL || animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN) { return }
        // console.log("PVC idx[" + index + "]. cancelZoomIn: ", cancelZoomIn, ". animationState: ", animationState)
        playCacharroAnimationZoomInReverse()
    }, [cancelZoomIn])

    const isCacharroMobile = experienceData.cacharro_type === `cacharro_mobile`
    const isCacharroLaptop = experienceData.cacharro_type === `cacharro_laptop`
    const cacharroScale = [0.3, 0.3, 0.3]

    const cacharroHolderAnimationMixer = new THREE.AnimationMixer(cacharroHolder)
    const cacharroZoomInAnimationAction = cacharroHolderAnimationMixer.clipAction(
        THREE.AnimationClip.findByName(portfolioAssetsAnimations, "cacharro-zoom-in"),
    )
    cacharroZoomInAnimationAction.play()

    const animationDuration = cacharroZoomInAnimationAction.getClip().duration
    if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. animationDuration: " + animationDuration) }

    const [hovered, setCursorHovered] = useState(false)
    useCursor(hovered)

    const cacharroGLTF = useGLTF(preload_assets.glbUrls[experienceData.cacharro_type])
    // console.log("cacharroGLTF.scene")
    // console.log(cacharroGLTF.scene)
    // console.log("cacharroGLTF.scene.children.length")
    // console.log(cacharroGLTF.scene.children.length)
    const cacharroScene = cacharroGLTF.scene.getObjectByName("cacharro").clone()
    cacharroScene.material = cacharroMaterial
    if (cacharroScene != null && cacharroScene.children.length > 0) {
        // console.log(cacharroGLTF.scene.children.length)
        for (var i = 0; i < cacharroScene.children.length; i++) {
            // console.log(cacharroScene.children[i])
            if (cacharroScene.children[i].material != undefined) {
                if (cacharroScene.children[i].material.name === "buttons") {
                    cacharroScene.children[i].material.color.set(buttonsColor)
                }
                else {
                    cacharroScene.children[i].material = cacharroMaterial
                }
            }
        }
    }

    const [animationState] = useState({
        animationTime: 0,
        animationStatus: AnimationStatus.STOPPED,
        positionStatus: PositionStatus.NORMAL,
        scrollingTowardsPosition: -1
    })

    window.addEventListener('wheel', function (event) {
        if (animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN) {
            // console.log("PVC idx[" + index + "]. wheel event. animationStatus: " + animationState.animationStatus)
            playCacharroAnimationZoomInReverse()
        }
    })

    const cacharroMaterialHolderMeshRef = useRef()
    let cacharroMaterialMeshPosition = [0, 0.03, 0.07]
    if (isCacharroMobile) {
        cacharroMaterialMeshPosition = [0, 0.03, 0.13]
    }
    else if (isCacharroLaptop) {
        cacharroMaterialMeshPosition = [0, 0.09, -0.00]
    }
    let cacharroMaterialMeshScale = [1, 1, 1]
    if (isCacharroMobile) {
        cacharroMaterialMeshScale = [0.55, 1.9, 1]
    }
    else if (isCacharroLaptop) {
        cacharroMaterialMeshScale = [1, 1, 1]
    }
    let cacharroMaterialMeshRotationX = 0.0
    if (isCacharroLaptop) {
        cacharroMaterialMeshRotationX = 0.16
    }

    useEffect(() => {
        // initial setup, called once

        // cacharroMaterialHolderMeshRef.current.position.set(0, 0.03, isMobile ? 0.13 : 0.07)
        // cacharroMaterialHolderMeshRef.current.scale.set(isMobile ? [0.55, 1.9, 1] : [1, 1, 1])

        var experienceInfoContainer = document.getElementsByClassName('experience-info-container')[0]
        if (experienceInfoContainer == undefined) {
            // this happens some times and not sure why.. but still works
            console.error("!! A) PortfolioVisualComponent.useEffect: experienceInfoContainer not found")
            return
        }
        experienceInfoContainer.dataset.experienceIndex = -1
    }, [])

    useFrame((_, delta) => {
        const distance = getDistanceToCenter(movingBall, experienceRef.current).toFixed(2)
        // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. distance: ", distance) }
        const isInCenter = distance < distanceToCenterThreshold
        const isCloseToCenter = distance < distanceToCenterThreshold * 0.9
        // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. useFrame start. isInCenter: " + isInCenter + ", animationState: " + JSON.stringify(animationState) + ", gettime: " + cacharroZoomInAnimationAction.getMixer().time) }

        if (isCloseToCenter) {
            // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. useFrame. isCloseToCenter. showExperienceInfoContainerData") }
            showExperienceInfoContainerData(experienceData)
        }
        else {
            // if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. useFrame. isNotCloseToCenter. hideExperienceInfoContainerData") }
            hideExperienceInfoContainerData()
        }

        // if is position zoom in but is not highlighted, go back to normal. check class titleHtml.classList.contains
        if (animationState.animationStatus == AnimationStatus.STOPPED
            && animationState.positionStatus == PositionStatus.ZOOM_IN
            && !isInCenter) {
            // console.log("PVC idx[" + index + "]. useFrame. animationStatus: " + animationState.animationStatus)
            playCacharroAnimationZoomInReverse()
        }
        else if (animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN) {
            const newAnimationTime = animationState.animationTime + delta
            if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. PLAYING_ZOOM_IN udpate. newAnimationTime: " + newAnimationTime) }
            cacharroZoomInAnimationAction.getMixer().setTime(newAnimationTime)
            animationState.animationTime = newAnimationTime

            if (newAnimationTime >= animationDuration - 0.01) {
                if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. useFrame. animation 1-PLAYING_ZOOM_IN STOPPED. animationState: " + JSON.stringify(animationState) + ", gettime: " + cacharroZoomInAnimationAction.getMixer().time) }
                stopCacharroAnimationZoomIn(PositionStatus.ZOOM_IN, animationDuration - 0.01)
            }
        }
        else if (animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN_REVERSE) {
            const newAnimationTime = animationState.animationTime - delta
            if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. PLAYING_ZOOM_IN_REVERSE udpate. newAnimationTime: " + newAnimationTime) }
            cacharroZoomInAnimationAction.getMixer().setTime(newAnimationTime)
            animationState.animationTime = newAnimationTime

            if (newAnimationTime <= 0.01) {
                if (index == enableLogIndex) { console.log("PVC idx[" + index + "]. useFrame. animation 2-PLAYING_ZOOM_IN_REVERSE STOPPED. animationState: " + JSON.stringify(animationState)) }
                stopCacharroAnimationZoomIn(PositionStatus.NORMAL, 0.0)
            }
        }

        // if (lastScrollY != window.scrollY) {
        // if (index == 0) { console.log("PVC idx[" + index + "]. useFrame. animationState: " + JSON.stringify(animationState)) }

        //     if (animationState.scrollingTowardsPosition != -1) {
        //         let isGoingIntoDirection = false

        //         if (animationState.animationStatus == AnimationStatus.PLAYING_ZOOM_IN) {
        //             const destination = animationState.scrollingTowardsPosition
        //             const currentDistance = Math.abs(window.scrollY - destination)
        //             const previousDistance = Math.abs(lastScrollY - destination)
        //             isGoingIntoDirection = currentDistance < previousDistance
        //             if (index == 0) {
        // if (index == 0) {console.log("PVC idx[" + index + "]. useFrame. isGoingIntoDirection: " + isGoingIntoDirection)}
        //             }

        //             if (!isGoingIntoDirection) {
        //                 playCacharroAnimationZoomInReverse()
        //             }
        //         }
        //     }
        // }

        // lastScrollY = window.scrollY
    })

    function VideoMaterial({ url }) {
        const shouldPlayVideo = isMobile()
        const texture = useVideoTexture(url, {
            start: shouldPlayVideo,
        })
        return <meshBasicMaterial
            map={texture}
            toneMapped={false}
        />
    }

    function FallbackMaterial({ url }) {
        const texture = useTexture(url)
        return <meshBasicMaterial
            map={texture}
            toneMapped={false}
        />
    }

    return (
        <>
            <group
                ref={experienceRef}
                name={"experience-only-group"}
                position={[0, -startExperiencesRotationCameraUnits, 0]}
            >
                <group
                    name={"experience-no-float"}
                    position={[0, cacharroPositionY, 2]}
                >
                    {/* <mesh
                        name={"experience-the-float-mesh-reference-position"}
                    >
                        <sphereGeometry args={[0.1, 32, 32]} />
                        <meshBasicMaterial color={0xffff00} />
                    </mesh> */}
                </group>

                <Float
                    name={"experience-the-float"}
                    speed={floatSpeedValue}
                    // floatIntensity={0.0}
                    rotationIntensity={0.1}
                    floatingRange={[0.0, 0.0]}
                >
                    <mesh
                        name={"experience-float-mesh"}
                        material={cacharroMaterial}
                        position={[0, cacharroPositionY, 2]}
                    >
                        <primitive
                            object={cacharroHolder}
                            // position={[0, positionY, 2]}
                            // rotation-x={[0.2]}
                            scale={cacharroScale}
                        >
                            <primitive
                                object={cacharroScene}
                                onClick={onClickEventHandler}
                                onPointerEnter={(event) => onCursorHoverEventHandler(event, true)}
                                onPointerLeave={(event) => onCursorHoverEventHandler(event, false)}
                            >
                                <mesh
                                    ref={cacharroMaterialHolderMeshRef}
                                    position={cacharroMaterialMeshPosition}
                                    scale={cacharroMaterialMeshScale}
                                    rotation-x={[cacharroMaterialMeshRotationX]}
                                >
                                    <planeGeometry args={[1.6, 0.9]} />
                                    <Suspense fallback={
                                        <FallbackMaterial url={preload_assets.textures.dizzy} />}>
                                        <VideoMaterial
                                            url={experienceData.media_url}
                                        />
                                    </Suspense>
                                </mesh>
                            </primitive>

                        </primitive>
                    </mesh>
                </Float>

                {/* <Html
                    key={"exp_" + index}
                    name={"experience-html"}
                    className='pvc-experience-title pvc-experience-title-hidden'
                    position={[0, cacharroPositionY + (isMobile ? 1.0 : 0.5), 2]}
                    rotation-x={[0.2]}
                    distanceFactor={1.5}
                    center
                >
                    {experienceData["title"]}
                </Html> */}
            </group>
        </>)
}

export { updatePorfolioVisualComponentCacharroHeaderText, updateDebugHighlightExperienceDistanceToCenterBall }